import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useAppDispatch } from 'Context/AppContext/AppContext'
import {
  UPDATE_FEATURE_FLAGS,
  UPDATE_FEATURE_FLAGS_LOADING,
} from 'TypeDefs/AppContext'
import { useQuery } from '@apollo/client'
import GET_FEATURE_FLAGS from 'Apollo/Queries/GetFeatureFlags'

const useFeatureFlagsLoader = () => {
  const { isAuthenticated } = useAuth0()
  const dispatch = useAppDispatch()

  const { data, loading } = useQuery(GET_FEATURE_FLAGS, {
    context: { clientName: 'batched' },
    skip: !isAuthenticated,
  })

  useEffect(() => {
    if (data && !loading && data.getFeatureFlags.featureFlags) {
      dispatch({
        type: UPDATE_FEATURE_FLAGS,
        activeFeatureFlags: data.getFeatureFlags.featureFlags,
      })
    }
  }, [data, loading, dispatch])

  useEffect(() => {
    dispatch({
      type: UPDATE_FEATURE_FLAGS_LOADING,
      loading,
    })
  }, [loading, dispatch])
}
export default useFeatureFlagsLoader
